export default __webpack_public_path__ + "static/media/LogoKahshNewPlus.933e6b65.svg";